import React from 'react';
import FeatureTag from './FeatureTag';
import './MarketCard.css';

/**
 * MarketCard Component
 * Market card for displaying market information
 * 
 * @param {string} title - Card title
 * @param {string} description - Card description
 * @param {Array} features - Array of feature text strings
 * @param {string} badge - Optional badge text (e.g., "Upcoming")
 * @param {string} className - Additional CSS classes
 */
const MarketCard = ({ title, description, features = [], badge, className = '' }) => {
  return (
    <div className={`market-card ${className}`}>
      {badge && (
        <div className="card-header">
          <h3>{title}</h3>
          <div className="upcoming-badge">{badge}</div>
        </div>
      )}
      {!badge && (
        <h3>{title}</h3>
      )}
      <p>{description}</p>
      {features.length > 0 && (
        <div className="market-features">
          {features.map((feature, index) => (
            <FeatureTag key={index} text={feature} />
          ))}
        </div>
      )}
    </div>
  );
};

export default MarketCard;























